// Specification Pattern
class Specification {
}
class OnlyPriceSpec extends Specification {
    constructor() {
        super(...arguments);
        this.type = "OnlyPrice";
    }
    isSatisfiedBy(candidate) {
        return candidate.hasMarkdown === false && candidate.hasAppliedDiscountCode === false && candidate.isPixDiscountCodeActive === false && candidate.isPointsDiscountCode === false && candidate.isCashbackDiscountCode === false;
    }
}
class PriceWithPixSpec extends Specification {
    constructor() {
        super(...arguments);
        this.type = "PriceWithPix";
    }
    isSatisfiedBy(candidate) {
        return candidate.hasMarkdown === false && candidate.hasAppliedDiscountCode === false && candidate.isPixDiscountCodeActive === true && candidate.isPointsDiscountCode === false && candidate.isCashbackDiscountCode === false;
    }
}
class PriceWithDiscountCodeSpec extends Specification {
    constructor() {
        super(...arguments);
        this.type = "PriceWithDiscountCode";
    }
    isSatisfiedBy(candidate) {
        return candidate.hasMarkdown === false && candidate.hasAppliedDiscountCode === true && candidate.isPixDiscountCodeActive === false && candidate.isPointsDiscountCode === false && candidate.isCashbackDiscountCode === false;
    }
}
class PriceWithMarkdownSpec extends Specification {
    constructor() {
        super(...arguments);
        this.type = "PriceWithMarkdown";
    }
    isSatisfiedBy(candidate) {
        return candidate.hasMarkdown === true && candidate.hasAppliedDiscountCode === false && candidate.isPixDiscountCodeActive === false && candidate.isPointsDiscountCode === false && candidate.isCashbackDiscountCode === false;
    }
}
class PriceWithDiscountCodeAndPixSpec extends Specification {
    constructor() {
        super(...arguments);
        this.type = "PriceWithDiscountCodeAndPix";
    }
    isSatisfiedBy(candidate) {
        return candidate.hasMarkdown === false && candidate.hasAppliedDiscountCode === true && candidate.isPixDiscountCodeActive === true && candidate.isPointsDiscountCode === false && candidate.isCashbackDiscountCode === false;
    }
}
class PriceWithMarkdownAndPixSpec extends Specification {
    constructor() {
        super(...arguments);
        this.type = "PriceWithMarkdownAndPix";
    }
    isSatisfiedBy(candidate) {
        return candidate.hasMarkdown === true && candidate.hasAppliedDiscountCode === false && candidate.isPixDiscountCodeActive === true && candidate.isPointsDiscountCode === false && candidate.isCashbackDiscountCode === false;
    }
}
class PriceWithMarkdownAndDiscountCodeSpec extends Specification {
    constructor() {
        super(...arguments);
        this.type = "PriceWithMarkdownAndDiscountCode";
    }
    isSatisfiedBy(candidate) {
        return candidate.hasMarkdown === true && candidate.hasAppliedDiscountCode === true && candidate.isPixDiscountCodeActive === false && candidate.isPointsDiscountCode === false && candidate.isCashbackDiscountCode === false;
    }
}
class PriceWithMarkdownAndDiscountCodeAndPixSpec extends Specification {
    constructor() {
        super(...arguments);
        this.type = "PriceWithMarkdownAndDiscountCodeAndPix";
    }
    isSatisfiedBy(candidate) {
        return candidate.hasMarkdown === true && candidate.hasAppliedDiscountCode === true && candidate.isPixDiscountCodeActive === true && candidate.isPointsDiscountCode === false && candidate.isCashbackDiscountCode === false;
    }
}
class PriceWithPointsSpec extends Specification {
    constructor() {
        super(...arguments);
        this.type = "PriceWithPoints";
    }
    isSatisfiedBy(candidate) {
        return candidate.hasMarkdown === false && candidate.hasAppliedDiscountCode === false && candidate.isPixDiscountCodeActive === false && candidate.isPointsDiscountCode === true && candidate.isCashbackDiscountCode === false;
    }
}
class PriceWithPointsAndPixSpec extends Specification {
    constructor() {
        super(...arguments);
        this.type = "PriceWithPointsAndPix";
    }
    isSatisfiedBy(candidate) {
        return candidate.hasMarkdown === false && candidate.hasAppliedDiscountCode === false && candidate.isPixDiscountCodeActive === true && candidate.isPointsDiscountCode === true && candidate.isCashbackDiscountCode === false;
    }
}
class PriceWithPointsAndMarkdownSpec extends Specification {
    constructor() {
        super(...arguments);
        this.type = "PriceWithPointsAndMarkdown";
    }
    isSatisfiedBy(candidate) {
        return candidate.hasMarkdown === true && candidate.hasAppliedDiscountCode === false && candidate.isPixDiscountCodeActive === false && candidate.isPointsDiscountCode === true && candidate.isCashbackDiscountCode === false;
    }
}
class PriceWithPointsAndMarkdownAndPixSpec extends Specification {
    constructor() {
        super(...arguments);
        this.type = "PriceWithPointsAndMarkdownAndPix";
    }
    isSatisfiedBy(candidate) {
        return candidate.hasMarkdown === true && candidate.hasAppliedDiscountCode === false && candidate.isPixDiscountCodeActive === true && candidate.isPointsDiscountCode === true && candidate.isCashbackDiscountCode === false;
    }
}
class PriceWithCashbackSpec extends Specification {
    constructor() {
        super(...arguments);
        this.type = "PriceWithCashback";
    }
    isSatisfiedBy(candidate) {
        return candidate.hasMarkdown === false && candidate.hasAppliedDiscountCode === false && candidate.isPixDiscountCodeActive === false && candidate.isCashbackDiscountCode === true && candidate.isPointsDiscountCode === false;
    }
}
class PriceWithCashbackAndPixSpec extends Specification {
    constructor() {
        super(...arguments);
        this.type = "PriceWithCashbackAndPix";
    }
    isSatisfiedBy(candidate) {
        return candidate.hasMarkdown === false && candidate.hasAppliedDiscountCode === false && candidate.isPixDiscountCodeActive === true && candidate.isCashbackDiscountCode === true && candidate.isPointsDiscountCode === false;
    }
}
class PriceWithCashbackAndMarkdownSpec extends Specification {
    constructor() {
        super(...arguments);
        this.type = "PriceWithCashbackAndMarkdown";
    }
    isSatisfiedBy(candidate) {
        return candidate.hasMarkdown === true && candidate.hasAppliedDiscountCode === false && candidate.isPixDiscountCodeActive === false && candidate.isCashbackDiscountCode === true && candidate.isPointsDiscountCode === false;
    }
}
class PriceWithCashbackAndMarkdownAndPixSpec extends Specification {
    constructor() {
        super(...arguments);
        this.type = "PriceWithCashbackAndMarkdownAndPix";
    }
    isSatisfiedBy(candidate) {
        return candidate.hasMarkdown === true && candidate.hasAppliedDiscountCode === false && candidate.isPixDiscountCodeActive === true && candidate.isCashbackDiscountCode === true && candidate.isPointsDiscountCode === false;
    }
}
const allSpecs = [
    new PriceWithMarkdownAndDiscountCodeAndPixSpec(),
    new PriceWithMarkdownAndDiscountCodeSpec(),
    new PriceWithMarkdownAndPixSpec(),
    new PriceWithMarkdownSpec(),
    new PriceWithDiscountCodeSpec(),
    new PriceWithDiscountCodeAndPixSpec(),
    new PriceWithPointsAndMarkdownAndPixSpec(),
    new PriceWithPointsAndMarkdownSpec(),
    new PriceWithPointsAndPixSpec(),
    new PriceWithPointsSpec(),
    new PriceWithCashbackAndMarkdownAndPixSpec(),
    new PriceWithCashbackAndMarkdownSpec(),
    new PriceWithCashbackAndPixSpec(),
    new PriceWithCashbackSpec(),
    new PriceWithPixSpec(),
    new OnlyPriceSpec(),
];
function resolveType(candidate) {
    const spec = allSpecs.find(s => s.isSatisfiedBy(candidate));
    return spec === null || spec === void 0 ? void 0 : spec.type;
}
if (typeof window !== "undefined") {
    window.PriceNormalizeResolveType = resolveType;
}
